import { useCallback, useRef } from 'react';

export function useEvent_INTERNAL<P, R, Params extends P[]>(
  cbk?: (...params: Params) => R
): (...params: Params) => R {
  const ref = useRef(cbk);
  ref.current = cbk;
  return useCallback<any>((...params: Params) => ref.current?.(...params), []);
}
